import { OutboxStatusEnum } from '../../../platform/outbox/enums/outbox-status.enum';
import { AppSubjectEnum } from '../../../shared/modules/authz/enums/app-subject.enum';
import { CaslSubject } from '../../../shared/modules/authz/decorators/casl-subject.decorator';
import { BaseDto } from '../../../shared/modules/base/dtos/base.dto';

/**
 * Reminder log DTO for records
 */
@CaslSubject(AppSubjectEnum.REMINDER_LOG)
export class ReminderLogRecordDto extends BaseDto {
	/**
	 * Audit log ID
	 */
	auditLogId!: number;

	/**
	 * User ID
	 */
	userId!: number;

	/**
	 * Status of the record
	 */
	status!: OutboxStatusEnum;

	/**
	 * Composite key describing the event and action that triggered the reminder
	 */
	key!: string;

	/**
	 * Source subject of the message
	 */
	subject!: AppSubjectEnum;

	/**
	 * Source subject ID of the message
	 */
	subjectId!: number;

	/**
	 * Unique token for the reminder
	 */
	dispatchToken!: string;

	/**
	 * Timestamp for when the reminder was scheduled
	 */
	scheduledAt!: Date;

	/**
	 * The worker ID that reserved the reminder
	 */
	leasedBy?: string;

	/**
	 * Timestamp until when the reminder is reserved
	 */
	leasedUntil?: Date;

	/**
	 * Timestamp for when the reminder was dispatched
	 */
	dispatchedAt?: Date;

	/**
	 * Error message if the reminder failed to dispatch
	 */
	dispatchError?: string;
}
